import React from 'react'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const FoodComp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);

  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container sx={{
          width: "100%",
          maxWidth: "100%"
        }}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {hasModulePermission("Recipe Ingredients") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/recipe-bomtable' }}
                  permissions={permissions}
                  title="Recipe Ingredients"
                />
              )}

              {/* {hasModulePermission("Day Wise Food") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/daywisefood' }}
                permissions={permissions}
                title="Day Wise Food"
              />
                )} */}
                 {hasModulePermission("Day Wise Food") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/new-daywisefood' }}
                permissions={permissions}
                title="Day Wise Food"
              />
                )}

                  {hasModulePermission("Tiffin Service") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/TiffinDeliverytable' }}
                permissions={permissions}
                title="Tiffin Service"
              />
                )}

                
                  {hasModulePermission("Tiffin Delivery") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/TiffinDeliveryPersontable' }}
                permissions={permissions}
                title="Tiffin Delivery"
              />
                )}
                    {hasModulePermission("Tiffin Return") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/TiffinReturnTable' }}
                permissions={permissions}
                title="Tiffin Return"
              />
                )}


              {/* {hasModulePermission("Checkout") && ( 
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/checkout/CheckoutTable' }}
                  permissions={permissions}
                  title="Checkout"
                />
              )} */}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default FoodComp;